import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9k8dl8hpes2mi34sic0';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitted(true);
      return;
    }

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        body.append(key, value as string);
      }
    });

    try {
      const resp = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const responseText = await resp.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_) { /* ignore parse error */ }

      if (resp.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后再试';
        setFormError(msg);
      }
    } catch (_) {
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            有合作意向、资源建议或问题反馈？欢迎通过下方表单与我们联系
          </p>
        </div>

        {submitted ? (
          <div className="bg-background-100 border border-background-200/70 rounded-lg p-8 md:p-10 text-center">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
              <i className="ri-check-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">提交成功</h3>
            <p className="text-sm text-foreground-600">感谢您的留言，我们会尽快回复。</p>
          </div>
        ) : (
          <form
            id="contact-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8 space-y-4"
          >
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">昵称</label>
              <input
                type="text"
                id="contact-name"
                name="name"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="请输入您的昵称"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
              <input
                type="email"
                id="contact-email"
                name="email"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="请输入您的邮箱"
              />
            </div>
            <div>
              <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-700 mb-1.5">类型</label>
              <select
                id="contact-type"
                name="type"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 transition-colors appearance-none"
              >
                <option value="">请选择类型</option>
                <option value="合作">商务合作</option>
                <option value="建议">资源建议</option>
                <option value="反馈">问题反馈</option>
                <option value="其他">其他</option>
              </select>
            </div>
            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows={4}
                maxLength={500}
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 transition-colors resize-none"
                placeholder="请输入您的留言（最多500字）"
              ></textarea>
            </div>
            <div className="honeypot-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            {formError && (
              <p className="text-sm text-red-500">{formError}</p>
            )}
            <button
              type="submit"
              className="w-full py-3 bg-primary-500 text-white rounded-md text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              提交留言
            </button>
          </form>
        )}
      </div>
    </section>
  );
}